import styled from 'styled-components'

export const CenteredPreloader = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
`